// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox_3QZqG2lHVb0YsfZHasmFCz"};